import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e9bb3758&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e9bb3758&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bb3758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9bb3758')) {
      api.createRecord('e9bb3758', component.options)
    } else {
      api.reload('e9bb3758', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e9bb3758&scoped=true", function () {
      api.rerender('e9bb3758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/index.vue"
export default component.exports